import React from "react";

const MessageList = (props) => {
    let { pageNumber, totalPage, filter, messangerList, openDropBox, selectedValue } = props
    let cond = pageNumber === pageCount
    let backClickCond = pageNumber === 0
    let pageCount = Math.floor(Number(totalPage) / 9) + (Number(totalPage) % 9 > 0 ? 1 : 0)
    return (
        <div onClick={(e) => props.clickOutside(e, {})}>
            <div className="mg-messanger-header">
                <span className="mg-messanger-h1">MyGame Messenger</span>
                <span className="mg-messanger-h1-close" data-dismiss="modal" onClick={props.closeMyGameMessanger}>
                    <i className="fa fa-times" aria-hidden="true"></i>
                </span>
            </div>
            <div className="dropdown mg-dropdown"
                data-value='mg-dropdown'
                onClick={() => props.openDropDown()}>
                <span data-value='mg-dropdown'>{selectedValue}</span><span>
                    <i className="fa fa-angle-down mg-down-arrow" data-value='mg-dropdown'></i>
                </span>
                {openDropBox &&
                    <ul className="mg-options" data-value='mg-dropdown'>
                        {filter.map((opt, i) =>
                            <li data-value={`${opt.value}`} data-value='mg-dropdown'
                                onClick={(e) => props.setSelectedValue(e, opt)}
                            >{opt.key}</li>
                        )}
                    </ul>}
            </div>
            <div className="mg-messanger-flirer-info">
                {filter.map((opt, i) =>
                    opt.key !== 'All' &&
                    <div key={i} id="menu" >
                        <i className={`fa fa-circle menu-${(opt.key).replace(' ', '-')}`} id="menu-content" aria-hidden="true"></i>{opt.key}
                    </div>)}
            </div>
            <div>
                <table className="mg-messanger-table">
                    <tr>
                        <th className="mg-messanger-th" style={{ paddingLeft: '22px', width: '36%' }}>Date</th>
                        <th className="mg-messanger-th" style={{ width: '30%' }}>AccountName</th>
                        <th className="mg-messanger-th" style={{ width: '30%' }}>Author</th>
                        <th className="mg-messanger-th" style={{ width: '4%' }}></th>
                    </tr>
                    {messangerList.length > 0 &&
                        messangerList.map((obj) => {
                            return (
                                <tr>
                                    <td className="mg-messanger-td">
                                        <i className={`fa fa-circle menu-${(obj.status).replace(' ', '-')}`}
                                            id="menu-content"
                                            aria-hidden="true"></i>
                                        {obj.dateCreated}
                                    </td>
                                    <td className="accountNameList mg-messanger-td" >{obj.accountName}</td>
                                    <td className="mg-messanger-td">{obj.author}</td>
                                    <td className="mg-messanger-td">
                                        <i className="fa fa-info-circle"
                                            data-value='mg-showMessageinfo'
                                            onClick={(e) => props.messageinfo(e, obj)}
                                            style={{ opacity: "0.5" }} aria-hidden="true"></i>
                                    </td>
                                </tr>
                            )
                        })


                    }
                </table>
                {messangerList.length === 0 &&
                    <div className="mg-messanger-flex" style={{ flexDirection: 'column' }}>
                        <div className="mg-messanger-emptylist">Nothing here yet</div>
                        <div
                        style={{width:'150px'}}
                            onClick={props.createNewMessage}
                            className="mg-mesanger-createNewBtn">
                            CREATE NEW MESSAGE
                        </div>
                    </div>
                }
            </div>
            {messangerList.length > 0 &&
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '45px' }}>
                    <div
                        onClick={props.createNewMessage}
                        className="mg-mesanger-createNewBtn">
                        CREATE NEW
                    </div>
                    <div className="mg-mesanger-pagination">
                        <i className='glyphicon glyphicon-chevron-left'
                            disabled={pageNumber === 0 ? true : false}
                            style={{ color: pageNumber === 0 ? '#999' : '#FF4500', cursor: 'pointer' }}
                            onClick={() => !backClickCond && props.nextPage(pageNumber - 1)}
                        />
                        <span style={{ color: 'black' }}>{pageNumber + 1}</span>
                        <i className='glyphicon glyphicon-chevron-right'
                            disabled={pageNumber + 1 === pageCount ? true : false}
                            style={{ color: pageNumber + 1 === pageCount ? '#999' : '#FF4500', cursor: 'pointer' }}
                            onClick={() => !cond && props.nextPage(pageNumber + 1)}
                        />
                    </div>
                </div>

            }

        </div>
    );
};
export default MessageList;


/** WEBPACK FOOTER **
 ** ./src/components/MyGameMessanger2/MessageList.js
 **/